import { Asset, InspectionImages, QuestionImageEntry } from "../types/asset";

/**
 * Find the photos captured for a checklist question in the inspection record's
 * `images.byQuestion` map. The backend keys the map by the checklist question
 * id (e.g. `q_03_01_002`).
 */
export const findQuestionImages = (
    images: InspectionImages | null | undefined,
    questionId: string
): QuestionImageEntry | undefined => images?.byQuestion?.[questionId];

/**
 * The assetIds that aren't yet in the resolved-URL cache. Presigned URLs carry
 * a 7-day expiry, so once resolved for the session we don't re-resolve them.
 */
export const getUncachedAssetIds = (
    assetIds: string[],
    cache: Record<string, Asset>
): string[] => assetIds.filter((id) => !cache[id]);

/** Index resolved assets by their `asset_id` for merging into the cache. */
export const keyAssetsById = (assets: Asset[]): Record<string, Asset> =>
    assets.reduce<Record<string, Asset>>((acc, asset) => {
        acc[asset.asset_id] = asset;
        return acc;
    }, {});

/**
 * The cached assets for a question, in the question's original photo order.
 * Ids missing from the cache are dropped (e.g. an asset that failed to resolve).
 */
export const orderCachedAssets = (
    assetIds: string[],
    cache: Record<string, Asset>
): Asset[] => assetIds.map((id) => cache[id]).filter((asset): asset is Asset => Boolean(asset));
